// src/components/price-presentation/__private/__fragments/price-presentation-section.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  fragment AdditionalInformationPopoverGridLineItemMessageFragment on PricePresentationLineItemMessage {\n    ... on PriceLineText {\n      __typename\n      primary\n    }\n    ... on PriceLineHeading {\n      __typename\n      tag\n      size\n      primary\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  fragment AdditionalInformationPopoverGridLineItemEntryFragment on PricePresentationLineItemEntry {\n    primaryMessage {\n      ...AdditionalInformationPopoverGridLineItemMessageFragment\n    }\n    secondaryMessages {\n      ...AdditionalInformationPopoverGridLineItemMessageFragment\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  fragment AdditionalInformationPopoverGridSectionFragment on AdditionalInformationPopoverGridSection {\n    __typename\n    subSections {\n      header {\n        name {\n          primaryMessage {\n            ...AdditionalInformationPopoverGridLineItemMessageFragment\n          }\n        }\n      }\n      items {\n        name {\n          ...AdditionalInformationPopoverGridLineItemEntryFragment\n        }\n        enrichedValue {\n          ...AdditionalInformationPopoverGridLineItemEntryFragment\n        }\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  fragment AdditionalInformationPopoverListSectionFragment on AdditionalInformationPopoverListSection {\n    __typename\n    content {\n      __typename\n      items {\n        text\n      }\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  fragment IconFragments on Icon {\n    description\n    id\n    size\n    theme\n    title\n    withBackground\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  fragment ActionFragment on UILinkAction {\n    accessibility\n    analytics {\n      linkName\n      referrerId\n    }\n    resource {\n      value\n    }\n    target\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  fragment EGDSStandardLinkFragment on EGDSStandardLink {\n    action {\n      ...ActionFragment\n    }\n    standardLinkIcon: icon {\n      ...IconFragments\n    }\n    iconPosition\n    size\n    text\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  fragment AdditionalInformationPopoverTextSectionFragment on AdditionalInformationPopoverTextSection {\n    __typename\n    text {\n      ...EGDSStandardLinkFragment\n      text\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  fragment AdditionalInformationPopoverSectionFragment on AdditionalInformationPopoverSection {\n    __typename\n    ... on AdditionalInformationPopoverTextSection {\n      ...AdditionalInformationPopoverTextSectionFragment\n    }\n    ... on AdditionalInformationPopoverListSection {\n      ...AdditionalInformationPopoverListSectionFragment\n    }\n    ... on AdditionalInformationPopoverGridSection {\n      ...AdditionalInformationPopoverGridSectionFragment\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  fragment AdditionalInformationPopoverFragment on AdditionalInformationPopover {\n    icon {\n      id\n      description\n      size\n    }\n    enrichedSecondaries {\n      ...AdditionalInformationPopoverSectionFragment\n    }\n    analytics {\n      linkName\n      referrerId\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n  fragment PricePresentationAdditionalInformationDialogFooterButtonsFragment on EGDSButton {\n    accessibility\n    disabled\n    primary\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n  fragment PricePresentationAdditionalInformationDialogFooterFragment on EGDSDialogFooter {\n    ... on EGDSInlineDialogFooter {\n      buttons {\n        ...PricePresentationAdditionalInformationDialogFooterButtonsFragment\n      }\n    }\n    ... on EGDSStackedDialogFooter {\n      buttons {\n        ...PricePresentationAdditionalInformationDialogFooterButtonsFragment\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n  fragment PricePresentationAdditionalInformationDialogFragment on PricePresentationAdditionalInformationDialog {\n    closeAnalytics {\n      linkName\n      referrerId\n    }\n    enrichedSecondaries {\n      ...AdditionalInformationPopoverSectionFragment\n    }\n    footer {\n      ...PricePresentationAdditionalInformationDialogFooterFragment\n    }\n    icon {\n      id\n      description\n      size\n    }\n    openAnalytics {\n      linkName\n      referrerId\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        "\n  fragment PricePresentationAdditionalInformationPopoverFragment on PricePresentationAdditionalInformationPopover {\n    analytics {\n      linkName\n      referrerId\n    }\n    enrichedSecondaries {\n      ...AdditionalInformationPopoverSectionFragment\n    }\n    icon {\n      id\n      description\n      size\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _taggedTemplateLiteral([
        "\n  fragment PricePresentationAdditionalInformationFragment on PricePresentationAdditionalInformation {\n    ...PricePresentationAdditionalInformationDialogFragment\n    ...PricePresentationAdditionalInformationPopoverFragment\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _taggedTemplateLiteral([
        "\n  fragment IllustrationFragments on Illustration {\n    description\n    id\n    link: url\n  }\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _taggedTemplateLiteral([
        "\n  fragment MarkFragments on Mark {\n    description\n    id\n    markSize: size\n    url {\n      ... on HttpURI {\n        __typename\n        relativePath\n        value\n      }\n    }\n  }\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = _taggedTemplateLiteral([
        "\n  fragment UIGraphicFragment on UIGraphic {\n    ... on Icon {\n      ...IconFragments\n    }\n\n    ... on Mark {\n      ...MarkFragments\n    }\n\n    ... on Illustration {\n      ...IllustrationFragments\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = _taggedTemplateLiteral([
        "\n  fragment PriceLineTextFragment on PriceLineText {\n    __typename\n    additionalInfo {\n      ...AdditionalInformationPopoverFragment\n    }\n    additionalInformation {\n      ...PricePresentationAdditionalInformationFragment\n    }\n    graphic {\n      ...UIGraphicFragment\n    }\n    icon {\n      id\n      description\n      size\n    }\n    primary\n    theme\n    weight\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = _taggedTemplateLiteral([
        "\n  fragment InlinePriceLineTextFragment on InlinePriceLineText {\n    __typename\n    inlineItems {\n      ...PriceLineTextFragment\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = _taggedTemplateLiteral([
        "\n  fragment EGDSStandardBadgeFragment on EGDSStandardBadge {\n    accessibility\n    text\n    theme\n  }\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = _taggedTemplateLiteral([
        "\n  fragment PriceLineBadgeFragment on PriceLineBadge {\n    badge {\n      ...EGDSStandardBadgeFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = _taggedTemplateLiteral([
        "\n  fragment PriceLineHeadingFragment on PriceLineHeading {\n    __typename\n    additionalInfo {\n      ...AdditionalInformationPopoverFragment\n    }\n    additionalInformation {\n      ...PricePresentationAdditionalInformationFragment\n    }\n    icon {\n      description\n      id\n      size\n    }\n    primary\n    size\n    tag\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = _taggedTemplateLiteral([
        "\n  fragment PriceLineElementFragment on PricePresentationLineItemMessage {\n    __typename\n    ...PriceLineTextFragment\n    ...PriceLineHeadingFragment\n    ...InlinePriceLineTextFragment\n    ...PriceLineBadgeFragment\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = _taggedTemplateLiteral([
        "\n  fragment PricePresentationLineItemEntryFragment on PricePresentationLineItemEntry {\n    primaryMessage {\n      ...PriceLineElementFragment\n    }\n    secondaryMessages {\n      ...PriceLineElementFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = _taggedTemplateLiteral([
        "\n  fragment PricePresentationLineItemFragment on PricePresentationLineItem {\n    enrichedValue {\n      ...PricePresentationLineItemEntryFragment\n    }\n    name {\n      ...PricePresentationLineItemEntryFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = _taggedTemplateLiteral([
        "\n  fragment PricePresentationSubSectionFragment on PricePresentationSubSection {\n    header {\n      name {\n        primaryMessage {\n          ... on PriceLineText {\n            primary\n          }\n          ... on PriceLineHeading {\n            primary\n          }\n        }\n      }\n      enrichedValue {\n        ...PricePresentationLineItemEntryFragment\n      }\n    }\n    items {\n      ...PricePresentationLineItemFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = _taggedTemplateLiteral([
        "\n  fragment PricePresentationSectionFragment on PricePresentationSection {\n    header {\n      name {\n        ...PricePresentationLineItemEntryFragment\n      }\n      enrichedValue {\n        ...PricePresentationLineItemEntryFragment\n      }\n    }\n    subSections {\n      ...PricePresentationSubSectionFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject27 = function _templateObject27() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = _taggedTemplateLiteral([
        "\n  fragment PricePresentationFragment on PricePresentation {\n    title {\n      primary\n    }\n    sections {\n      ...PricePresentationSectionFragment\n    }\n    footer {\n      header\n      messages {\n        ...PriceLineElementFragment\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject28 = function _templateObject28() {
        return data;
    };
    return data;
}
import React27 from "react";
import { gql as gql28 } from "@apollo/client";
import { UitkCardContentSection } from "uitk-react-cards";
import { UitkSpacing as UitkSpacing10 } from "uitk-react-spacing";
import { UitkTable as UitkTable2, UitkTableBody as UitkTableBody2, UitkTableCell as UitkTableCell4, UitkTableCellPadding as UitkTableCellPadding4, UitkTableRow as UitkTableRow4 } from "uitk-react-tables";
// src/components/price-presentation/__private/__fragments/price-line-element.tsx
import React23 from "react";
import { gql as gql24 } from "@apollo/client";
// src/components/price-presentation/__private/__fragments/inline-price-line-text.tsx
import React19 from "react";
import { gql as gql20 } from "@apollo/client";
import { UitkLayoutFlex as UitkLayoutFlex5 } from "uitk-react-layout-flex";
// src/components/price-presentation/__private/__fragments/price-line-text.tsx
import React18 from "react";
import { gql as gql19 } from "@apollo/client";
import { UitkIcon as UitkIcon5, UitkIconSize as UitkIconSize5 } from "uitk-react-icons";
import { UitkLayoutFlex as UitkLayoutFlex4, UitkLayoutFlexItem } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing6 } from "uitk-react-spacing";
import { UitkText as UitkText4 } from "uitk-react-text";
// src/components/price-presentation/__private/__fragments/additional-information-popover.tsx
import React10 from "react";
import { gql as gql10 } from "@apollo/client";
import { useClickTracker as useClickTracker2 } from "@shared-ui/clickstream-analytics-context";
import { UitkIcon as UitkIcon2, UitkIconSize as UitkIconSize2 } from "uitk-react-icons";
import { UitkLayoutFlex } from "uitk-react-layout-flex";
import { UitkLink as UitkLink2 } from "uitk-react-link";
import { PositionType, UitkMenu, UitkMenuContainer, UitkMenuTrigger } from "uitk-react-menu";
import { UitkMoreInfoTrigger } from "uitk-react-more-info-trigger";
import { UitkSpacing as UitkSpacing3 } from "uitk-react-spacing";
// src/components/price-presentation/__private/__fragments/additional-information-popover-sections.tsx
import React8 from "react";
import { gql as gql9 } from "@apollo/client";
import { UitkSpacing as UitkSpacing2 } from "uitk-react-spacing";
// src/components/price-presentation/__private/__fragments/additional-information-popover-grid/additional-information-popover-grid-section.tsx
import React3 from "react";
import { gql as gql3 } from "@apollo/client";
import { UitkSpacing } from "uitk-react-spacing";
import { UitkTable, UitkTableBody, UitkTableCell, UitkTableCellPadding, UitkTableRow } from "uitk-react-tables";
// src/components/price-presentation/__private/__fragments/additional-information-popover-grid/additional-information-popover-grid-line-item-entry.tsx
import React2 from "react";
import { gql as gql2 } from "@apollo/client";
// src/components/price-presentation/__private/__fragments/additional-information-popover-grid/additional-information-popover-grid-line-item-message.tsx
import React from "react";
import { gql } from "@apollo/client";
import { UitkHeading, UitkText } from "uitk-react-text";
var fragment = gql(_templateObject());
var AdditionalInformationPopoverGridLineItemMessage = function(param) {
    var data = param.data, size = param.size;
    if (!data) {
        return null;
    }
    switch(data.__typename){
        case "PriceLineText":
            return /* @__PURE__ */ React.createElement(UitkText, {
                size: size
            }, data.primary);
        case "PriceLineHeading":
            return /* @__PURE__ */ React.createElement(UitkHeading, {
                size: Number(data.size),
                tag: data.tag
            }, data.primary);
        default:
            return null;
    }
};
AdditionalInformationPopoverGridLineItemMessage.displayName = "AdditionalInformationPopoverGridLineItemMessage";
AdditionalInformationPopoverGridLineItemMessage.fragment = fragment;
// src/components/price-presentation/__private/__fragments/additional-information-popover-grid/additional-information-popover-grid-line-item-entry.tsx
var fragment2 = gql2(_templateObject1(), AdditionalInformationPopoverGridLineItemMessage.fragment);
var AdditionalInformationPopoverGridLineItemEntry = function(param) {
    var data = param.data;
    if (!data) {
        return null;
    }
    var primaryMessage = data.primaryMessage, secondaryMessages = data.secondaryMessages;
    return /* @__PURE__ */ React2.createElement(React2.Fragment, null, /* @__PURE__ */ React2.createElement(AdditionalInformationPopoverGridLineItemMessage, {
        data: primaryMessage
    }), secondaryMessages.map(function(secondaryMessage, index) {
        return /* @__PURE__ */ React2.createElement(AdditionalInformationPopoverGridLineItemMessage, {
            key: index,
            size: 200,
            data: secondaryMessage
        });
    }));
};
AdditionalInformationPopoverGridLineItemEntry.displayName = "AdditionalInformationPopoverGridLineItemEntry";
AdditionalInformationPopoverGridLineItemEntry.fragment = fragment2;
// src/components/price-presentation/__private/__fragments/additional-information-popover-grid/additional-information-popover-grid-section.tsx
var fragment3 = gql3(_templateObject2(), AdditionalInformationPopoverGridLineItemEntry.fragment, AdditionalInformationPopoverGridLineItemMessage.fragment);
var AdditionalInformationPopoverGridSection = function(param) {
    var data = param.data;
    var subSections = data.subSections;
    if (!subSections.length) {
        return null;
    }
    return /* @__PURE__ */ React3.createElement(UitkTable, null, /* @__PURE__ */ React3.createElement(UitkTableBody, null, subSections.map(function(section, sectionIndex) {
        var header = section.header, items = section.items;
        var heading = header === null || header === void 0 ? void 0 : header.name.primaryMessage;
        return /* @__PURE__ */ React3.createElement(React3.Fragment, {
            key: sectionIndex
        }, heading && /* @__PURE__ */ React3.createElement(UitkTableRow, null, /* @__PURE__ */ React3.createElement(UitkTableCell, {
            colSpan: 2,
            padding: UitkTableCellPadding.zero
        }, /* @__PURE__ */ React3.createElement(UitkSpacing, {
            padding: sectionIndex ? {
                blockstart: "six",
                blockend: "three"
            } : {
                blockend: "three"
            }
        }, /* @__PURE__ */ React3.createElement("div", null, /* @__PURE__ */ React3.createElement(AdditionalInformationPopoverGridLineItemMessage, {
            data: heading
        }))))), items.map(function(item, itemIndex) {
            var name = item.name, enrichedValue = item.enrichedValue;
            var padding = itemIndex || sectionIndex && !heading ? {
                blockstart: "three"
            } : void 0;
            return /* @__PURE__ */ React3.createElement(UitkTableRow, {
                key: itemIndex
            }, /* @__PURE__ */ React3.createElement(UitkTableCell, {
                colSpan: enrichedValue ? 1 : 2,
                padding: UitkTableCellPadding.zero
            }, /* @__PURE__ */ React3.createElement(UitkSpacing, {
                padding: padding
            }, /* @__PURE__ */ React3.createElement("div", null, /* @__PURE__ */ React3.createElement(AdditionalInformationPopoverGridLineItemEntry, {
                data: name
            })))), /* @__PURE__ */ React3.createElement(React3.Fragment, null, enrichedValue && /* @__PURE__ */ React3.createElement(UitkTableCell, {
                align: {
                    horizontal: "trailing"
                },
                padding: UitkTableCellPadding.zero
            }, /* @__PURE__ */ React3.createElement(UitkSpacing, {
                padding: padding
            }, /* @__PURE__ */ React3.createElement("div", null, /* @__PURE__ */ React3.createElement(AdditionalInformationPopoverGridLineItemEntry, {
                data: enrichedValue
            }))))));
        }));
    })));
};
AdditionalInformationPopoverGridSection.displayName = "AdditionalInformationPopoverGridSection";
AdditionalInformationPopoverGridSection.fragment = fragment3;
// src/components/price-presentation/__private/__fragments/additional-information-popover-list-section.tsx
import React4 from "react";
import { gql as gql4 } from "@apollo/client";
import { UitkList } from "uitk-react-list";
var fragment4 = gql4(_templateObject3());
var AdditionalInformationPopoverListSection = function(param) {
    var data = param.data, listProps = param.listProps;
    var items = data.content.items.map(function(item) {
        return item.text;
    });
    var listType = data.content.__typename === "EGDSOrderedList" ? "ordered" : "unordered";
    return /* @__PURE__ */ React4.createElement(UitkList, {
        data: items,
        size: listProps === null || listProps === void 0 ? void 0 : listProps.size,
        type: listType
    });
};
AdditionalInformationPopoverListSection.displayName = "AdditionalInformationPopoverListSection";
AdditionalInformationPopoverListSection.fragment = fragment4;
AdditionalInformationPopoverListSection.fragment.__typename = "AdditionalInformationPopoverListSection";
// src/components/price-presentation/__private/__fragments/additional-information-popover-text-section.tsx
import React7 from "react";
import { gql as gql8 } from "@apollo/client";
import { UitkText as UitkText2 } from "uitk-react-text";
// src/components/price-presentation/__private/__fragments/egds-standard-link/egds-standard-link.tsx
import React6 from "react";
import { gql as gql7 } from "@apollo/client";
import { useClickTracker } from "@shared-ui/clickstream-analytics-context";
import { UitkLink } from "uitk-react-link";
// src/components/price-presentation/__private/__fragments/icon.tsx
import React5 from "react";
import { gql as gql5 } from "@apollo/client";
import { UitkIcon, UitkIconSize } from "uitk-react-icons";
var IconFragment = gql5(_templateObject4());
var _data_title, _data_theme;
var Icon = function(param) {
    var className = param.className, data = param.data, spotlight = param.spotlight;
    /* @__PURE__ */ return React5.createElement(UitkIcon, {
        className: className,
        description: data.description,
        id: data.id,
        name: data.id,
        size: data.size ? UitkIconSize[data.size] : void 0,
        title: (_data_title = data.title) !== null && _data_title !== void 0 ? _data_title : void 0,
        theme: (_data_theme = data === null || data === void 0 ? void 0 : data.theme) !== null && _data_theme !== void 0 ? _data_theme : void 0,
        shadow: Boolean(data.withBackground),
        spotlight: spotlight !== null && spotlight !== void 0 ? spotlight : void 0
    });
};
Icon.displayName = "UitkIcon";
Icon.fragment = IconFragment;
// src/components/price-presentation/__private/__fragments/egds-standard-link/link-action.tsx
import { gql as gql6 } from "@apollo/client";
var linkActionFragment = gql6(_templateObject5());
var _obj;
// src/components/price-presentation/__private/__fragments/egds-standard-link/link-size.ts
var linkSizeMapper = (_obj = {}, _defineProperty(_obj, "SMALL" /* SMALL */ , "small"), _defineProperty(_obj, "MEDIUM" /* MEDIUM */ , "medium"), _defineProperty(_obj, "LARGE" /* LARGE */ , "medium"), _obj);
var _obj1;
// src/components/price-presentation/__private/__fragments/egds-standard-link/link-target.ts
var UILinkTargetMap = (_obj1 = {}, _defineProperty(_obj1, "EXTERNAL" /* EXTERNAL */ , "_blank"), _defineProperty(_obj1, "INTERNAL" /* INTERNAL */ , "_self"), _obj1);
// src/components/price-presentation/__private/__fragments/egds-standard-link/egds-standard-link.tsx
var fragment5 = gql7(_templateObject6(), linkActionFragment, Icon.fragment);
var IconPlacement = function(param) {
    var icon = param.icon, iconPosition = param.iconPosition, iconPositionToMatch = param.iconPositionToMatch;
    if (icon && iconPosition === iconPositionToMatch) {
        return /* @__PURE__ */ React6.createElement(Icon, {
            data: icon
        });
    }
    return null;
};
var EGDSStandardLink = function(param) {
    var className = param.className, inline = param.inline, align = param.align, _param_data = param.data, _param_data_action = _param_data.action, analytics = _param_data_action.analytics, resource = _param_data_action.resource, target = _param_data_action.target, iconPosition = _param_data.iconPosition, standardLinkIcon = _param_data.standardLinkIcon, size = _param_data.size, text = _param_data.text;
    var clickTracker = useClickTracker();
    var onClick = React6.useCallback(function() {
        clickTracker(analytics.referrerId, analytics.linkName);
    }, [
        clickTracker,
        analytics
    ]);
    return /* @__PURE__ */ React6.createElement(UitkLink, {
        className: className,
        size: linkSizeMapper[size],
        onClickCapture: onClick,
        inline: inline,
        align: align
    }, /* @__PURE__ */ React6.createElement("a", {
        target: UILinkTargetMap[target],
        href: resource.value
    }, /* @__PURE__ */ React6.createElement(IconPlacement, {
        icon: standardLinkIcon,
        iconPosition: iconPosition,
        iconPositionToMatch: "LEADING" /* LEADING */ 
    }), text, /* @__PURE__ */ React6.createElement(IconPlacement, {
        icon: standardLinkIcon,
        iconPosition: iconPosition,
        iconPositionToMatch: "TRAILING" /* TRAILING */ 
    })));
};
EGDSStandardLink.fragment = fragment5;
EGDSStandardLink.displayName = "EGDSStandardLink";
// src/components/price-presentation/__private/__fragments/additional-information-popover-text-section.tsx
var fragment6 = gql8(_templateObject7(), EGDSStandardLink.fragment);
var AdditionalInformationPopoverTextSection = function(param) {
    var data = param.data, textProps = param.textProps;
    switch(data.text.__typename){
        case "EGDSStandardLink":
            return /* @__PURE__ */ React7.createElement(EGDSStandardLink, {
                data: data.text
            });
        default:
            return /* @__PURE__ */ React7.createElement(UitkText2, {
                size: (textProps === null || textProps === void 0 ? void 0 : textProps.size) || 300,
                theme: textProps === null || textProps === void 0 ? void 0 : textProps.theme,
                weight: textProps === null || textProps === void 0 ? void 0 : textProps.weight,
                inline: true
            }, data.text.text);
    }
};
AdditionalInformationPopoverTextSection.displayName = "AdditionalInformationPopoverTextSection";
AdditionalInformationPopoverTextSection.fragment = fragment6;
AdditionalInformationPopoverTextSection.fragment.__typename = "AdditionalInformationPopoverTextSection";
// src/components/price-presentation/__private/__fragments/additional-information-popover-sections.tsx
var fragment7 = gql9(_templateObject8(), AdditionalInformationPopoverTextSection.fragment, AdditionalInformationPopoverListSection.fragment, AdditionalInformationPopoverGridSection.fragment);
var AdditionalInformationPopoverSection = function(param) {
    var enrichedSecondary = param.enrichedSecondary;
    switch(enrichedSecondary.__typename){
        case "AdditionalInformationPopoverListSection":
            return /* @__PURE__ */ React8.createElement(AdditionalInformationPopoverListSection, {
                data: enrichedSecondary
            });
        case "AdditionalInformationPopoverTextSection":
            return /* @__PURE__ */ React8.createElement(AdditionalInformationPopoverTextSection, {
                data: enrichedSecondary
            });
        case "AdditionalInformationPopoverGridSection":
            return /* @__PURE__ */ React8.createElement(AdditionalInformationPopoverGridSection, {
                data: enrichedSecondary
            });
        default:
            return null;
    }
};
var AdditionalInformationPopoverSections = function(param) {
    var data = param.data;
    return /* @__PURE__ */ React8.createElement(React8.Fragment, null, data.map(function(enrichedSecondary, index) {
        var isLastEnrichedSecondary = index === data.length - 1;
        return /* @__PURE__ */ React8.createElement(UitkSpacing2, {
            key: "additional-info-section-".concat(index),
            margin: isLastEnrichedSecondary ? void 0 : {
                blockend: "two"
            }
        }, /* @__PURE__ */ React8.createElement("div", null, /* @__PURE__ */ React8.createElement(AdditionalInformationPopoverSection, {
            enrichedSecondary: enrichedSecondary
        })));
    }));
};
AdditionalInformationPopoverSections.fragment = fragment7;
AdditionalInformationPopoverSections.displayName = "AdditionalInformationPopoverSections";
// src/components/price-presentation/__private/__fragments/price-presentation-additional-information-header.tsx
import React9 from "react";
import { UitkHeading as UitkHeading2, UitkText as UitkText3 } from "uitk-react-text";
var _obj2;
// src/components/price-presentation/__private/__fragments/text-theme.ts
var textThemeMapper = (_obj2 = {}, _defineProperty(_obj2, "EMPHASIS" /* EMPHASIS */ , "emphasis"), _defineProperty(_obj2, "INVERSE" /* INVERSE */ , "inverse"), _defineProperty(_obj2, "LOYALTY" /* LOYALTY */ , "loyalty"), _defineProperty(_obj2, "NEGATIVE" /* NEGATIVE */ , "negative"), _defineProperty(_obj2, "POSITIVE" /* POSITIVE */ , "positive"), _defineProperty(_obj2, "PRIMARY" /* PRIMARY */ , "emphasis"), _defineProperty(_obj2, "SECONDARY" /* SECONDARY */ , "default"), _obj2);
var _obj3;
// src/components/price-presentation/__private/__fragments/text-weight.ts
var textWeightMapper = (_obj3 = {}, _defineProperty(_obj3, "BOLD" /* BOLD */ , "bold"), _defineProperty(_obj3, "MEDIUM" /* MEDIUM */ , "medium"), _defineProperty(_obj3, "REGULAR" /* REGULAR */ , "regular"), _obj3);
// src/components/price-presentation/__private/__fragments/price-presentation-additional-information-header.tsx
var PricePresentationAdditionalInformationHeader = function(param) {
    var primaryMessage = param.primaryMessage, textProps = param.textProps;
    switch(primaryMessage === null || primaryMessage === void 0 ? void 0 : primaryMessage.__typename){
        case "PriceLineText":
            return /* @__PURE__ */ React9.createElement(UitkText3, {
                "data-stid": "price-presentation-additional-information-text",
                size: textProps === null || textProps === void 0 ? void 0 : textProps.size,
                theme: (primaryMessage === null || primaryMessage === void 0 ? void 0 : primaryMessage.theme) ? textThemeMapper[primaryMessage.theme] : void 0,
                weight: (primaryMessage === null || primaryMessage === void 0 ? void 0 : primaryMessage.weight) ? textWeightMapper[primaryMessage.weight] : void 0,
                inline: true
            }, primaryMessage === null || primaryMessage === void 0 ? void 0 : primaryMessage.primary);
        case "PriceLineHeading":
            return /* @__PURE__ */ React9.createElement(UitkHeading2, {
                "data-stid": "price-presentation-additional-information-heading",
                size: Number(primaryMessage.size),
                tag: primaryMessage.tag
            }, primaryMessage === null || primaryMessage === void 0 ? void 0 : primaryMessage.primary);
        default:
            return null;
    }
};
// src/components/price-presentation/__private/__fragments/additional-information-popover.tsx
var fragment8 = gql10(_templateObject9(), AdditionalInformationPopoverSections.fragment);
var AdditionalInformationPopover = function(param) {
    var data = param.data, primaryMessage = param.primaryMessage, textProps = param.textProps;
    var icon = data.icon, analytics = data.analytics, enrichedSecondaries = data.enrichedSecondaries;
    var _React10_useState = _slicedToArray(React10.useState(false), 2), isMenuOpen = _React10_useState[0], setIsMenuOpen = _React10_useState[1];
    var lineStartIcon = primaryMessage === null || primaryMessage === void 0 ? void 0 : primaryMessage.icon;
    var isLinkForPopup = (primaryMessage === null || primaryMessage === void 0 ? void 0 : primaryMessage.primary) && enrichedSecondaries.length > 0 && !icon;
    var track = useClickTracker2();
    if (!icon && !isLinkForPopup) {
        return null;
    }
    var toggleMenuOpen = function() {
        if (!isMenuOpen && analytics) {
            track(analytics.referrerId, analytics.linkName, false);
        }
        setIsMenuOpen(function(prevState) {
            return !prevState;
        });
    };
    var _ref;
    return /* @__PURE__ */ React10.createElement(UitkMenu, {
        isOpen: isMenuOpen,
        onTriggerClick: toggleMenuOpen
    }, /* @__PURE__ */ React10.createElement(UitkMenuTrigger, null, /* @__PURE__ */ React10.createElement("div", null, icon && /* @__PURE__ */ React10.createElement(UitkMoreInfoTrigger, null, /* @__PURE__ */ React10.createElement("button", {
        "data-stid": "additional-menu-btn",
        type: "button"
    }, /* @__PURE__ */ React10.createElement(UitkLayoutFlex, {
        alignItems: "center"
    }, lineStartIcon && /* @__PURE__ */ React10.createElement(UitkSpacing3, {
        margin: {
            inlineend: "one"
        }
    }, /* @__PURE__ */ React10.createElement("span", {
        "data-stid": "additional-menu-btn-discount-icon"
    }, /* @__PURE__ */ React10.createElement(UitkIcon2, {
        name: lineStartIcon.id,
        id: lineStartIcon.id,
        size: (_ref = lineStartIcon.size && UitkIconSize2[lineStartIcon.size]) !== null && _ref !== void 0 ? _ref : UitkIconSize2.EXTRA_SMALL,
        theme: "secondary",
        title: lineStartIcon.description
    }))), /* @__PURE__ */ React10.createElement(PricePresentationAdditionalInformationHeader, {
        primaryMessage: primaryMessage,
        textProps: textProps
    }), /* @__PURE__ */ React10.createElement(UitkSpacing3, {
        margin: {
            inlinestart: "one"
        }
    }, /* @__PURE__ */ React10.createElement("span", {
        "data-stid": "additional-menu-btn-info-icon"
    }, /* @__PURE__ */ React10.createElement(UitkIcon2, {
        name: icon.id,
        id: icon.id,
        size: UitkIconSize2.EXTRA_SMALL,
        theme: "secondary",
        title: icon.description
    })))))), isLinkForPopup && /* @__PURE__ */ React10.createElement(UitkLink2, {
        inline: true,
        "data-stid": "additional-menu-link"
    }, /* @__PURE__ */ React10.createElement("button", {
        type: "button"
    }, primaryMessage === null || primaryMessage === void 0 ? void 0 : primaryMessage.primary)))), (enrichedSecondaries === null || enrichedSecondaries === void 0 ? void 0 : enrichedSecondaries.length) && /* @__PURE__ */ React10.createElement(UitkMenuContainer, {
        autoPosition: true,
        position: PositionType.LEFT
    }, /* @__PURE__ */ React10.createElement(UitkSpacing3, {
        padding: {
            inline: "three"
        }
    }, /* @__PURE__ */ React10.createElement("div", null, /* @__PURE__ */ React10.createElement(AdditionalInformationPopoverSections, {
        data: enrichedSecondaries
    })))));
};
AdditionalInformationPopover.fragment = fragment8;
AdditionalInformationPopover.fragment.__typename = "AdditionalInformationPopover";
AdditionalInformationPopover.displayName = "AdditionalInformationPopover";
// src/components/price-presentation/__private/__fragments/price-presentation-additional-information.tsx
import React14 from "react";
import { gql as gql15 } from "@apollo/client";
// src/components/price-presentation/__private/__fragments/price-presentation-additional-information-dialog/price-presentation-additional-information-dialog.tsx
import React12, { useEffect } from "react";
import { gql as gql13 } from "@apollo/client";
import { useClickTracker as useClickTracker3 } from "@shared-ui/clickstream-analytics-context";
import { useDialog } from "@shared-ui/dialog-context";
import { UitkDialog, UitkDialogContent } from "uitk-react-dialog";
import { UitkIcon as UitkIcon3, UitkIconSize as UitkIconSize3 } from "uitk-react-icons";
import { UitkLayoutFlex as UitkLayoutFlex2 } from "uitk-react-layout-flex";
import { UitkMoreInfoTrigger as UitkMoreInfoTrigger2 } from "uitk-react-more-info-trigger";
import { UitkSpacing as UitkSpacing4 } from "uitk-react-spacing";
// src/components/price-presentation/__private/__fragments/price-presentation-additional-information-dialog/price-presentation-additional-information-dialog-footer.tsx
import React11 from "react";
import { gql as gql12 } from "@apollo/client";
import { UitkDialogFooter } from "uitk-react-dialog";
// src/components/price-presentation/__private/__fragments/price-presentation-additional-information-dialog/price-presentation-additional-information-dialog-footer-buttons.tsx
import { gql as gql11 } from "@apollo/client";
var __PricePresentationAdditionalInformationDialogFooterButtonsFragment = gql11(_templateObject10());
var getButton = function(data, closeDialog) {
    switch(data.__typename){
        case "UITertiaryButton":
            {
                var _data_primary;
                return {
                    disabled: data.disabled,
                    onClick: closeDialog,
                    text: (_data_primary = data.primary) !== null && _data_primary !== void 0 ? _data_primary : "",
                    type: "tertiary"
                };
            }
        case "UIPrimaryButton":
        default:
            var _data_primary1;
            return {
                disabled: data.disabled,
                onClick: closeDialog,
                text: (_data_primary1 = data.primary) !== null && _data_primary1 !== void 0 ? _data_primary1 : "",
                type: "primary"
            };
    }
};
// src/components/price-presentation/__private/__fragments/price-presentation-additional-information-dialog/price-presentation-additional-information-dialog-footer.tsx
var fragment9 = gql12(_templateObject11(), __PricePresentationAdditionalInformationDialogFooterButtonsFragment);
var PricePresentationAdditionalInformationDialogFooter = function(param) {
    var data = param.data, closeDialog = param.closeDialog;
    var buttons = data.buttons;
    var buttonMap = buttons.map(function(button) {
        return getButton(button, closeDialog);
    });
    var _buttonMap_, _buttonMap_1, _buttonMap_2;
    var props = {
        buttonOne: (_buttonMap_ = buttonMap[0]) !== null && _buttonMap_ !== void 0 ? _buttonMap_ : void 0,
        buttonTwo: (_buttonMap_1 = buttonMap[1]) !== null && _buttonMap_1 !== void 0 ? _buttonMap_1 : void 0,
        buttonThree: (_buttonMap_2 = buttonMap[2]) !== null && _buttonMap_2 !== void 0 ? _buttonMap_2 : void 0
    };
    switch(data.__typename){
        case "EGDSStackedDialogFooter":
            return /* @__PURE__ */ React11.createElement(UitkDialogFooter, _objectSpread({
                stacked: true
            }, props));
        default:
            return /* @__PURE__ */ React11.createElement(UitkDialogFooter, _objectSpread({}, props));
    }
};
PricePresentationAdditionalInformationDialogFooter.displayName = "PricePresentationAdditionalInformationDialogFooter";
PricePresentationAdditionalInformationDialogFooter.fragment = fragment9;
// src/components/price-presentation/__private/__fragments/price-presentation-additional-information-dialog/price-presentation-additional-information-dialog.tsx
var fragment10 = gql13(_templateObject12(), PricePresentationAdditionalInformationDialogFooter.fragment, AdditionalInformationPopoverSections.fragment);
var PricePresentationAdditionalInformationDialog = function(param) {
    var data = param.data, isRenderedInDialog = param.isRenderedInDialog, primaryMessage = param.primaryMessage, textProps = param.textProps;
    var closeAnalytics = data.closeAnalytics, enrichedSecondaries = data.enrichedSecondaries, footer = data.footer, icon = data.icon, openAnalytics = data.openAnalytics;
    var track = useClickTracker3();
    var _useDialog = _slicedToArray(useDialog("price-additional-information", isRenderedInDialog ? "pwaDialogNested" : void 0), 3), isOpen = _useDialog[0], dialogActions = _useDialog[1], DialogComponent = _useDialog[2];
    var toggleDialog = function() {
        if (!isOpen) {
            dialogActions.openDialog();
        } else {
            dialogActions.closeDialog();
        }
    };
    useEffect(function() {
        if (!isOpen && openAnalytics) {
            track(openAnalytics.referrerId, openAnalytics.linkName, false);
        } else if (isOpen && closeAnalytics) {
            track(closeAnalytics.referrerId, closeAnalytics.linkName, false);
        }
    }, [
        closeAnalytics,
        openAnalytics,
        isOpen,
        track
    ]);
    if (!(enrichedSecondaries === null || enrichedSecondaries === void 0 ? void 0 : enrichedSecondaries.length)) {
        return null;
    }
    return /* @__PURE__ */ React12.createElement("div", null, /* @__PURE__ */ React12.createElement(UitkLayoutFlex2, {
        alignItems: "center"
    }, /* @__PURE__ */ React12.createElement(UitkMoreInfoTrigger2, null, /* @__PURE__ */ React12.createElement("button", {
        onClick: toggleDialog,
        type: "button"
    }, /* @__PURE__ */ React12.createElement(UitkLayoutFlex2, {
        alignItems: "center"
    }, /* @__PURE__ */ React12.createElement(PricePresentationAdditionalInformationHeader, {
        primaryMessage: primaryMessage,
        textProps: textProps
    }), icon && /* @__PURE__ */ React12.createElement(UitkSpacing4, {
        margin: {
            inlinestart: "one"
        }
    }, /* @__PURE__ */ React12.createElement(UitkIcon3, {
        name: icon.id,
        id: icon.id,
        size: UitkIconSize3.EXTRA_SMALL,
        theme: "secondary",
        title: icon.description
    })))))), /* @__PURE__ */ React12.createElement(DialogComponent, null, /* @__PURE__ */ React12.createElement(UitkDialog, {
        dialogShow: isOpen
    }, /* @__PURE__ */ React12.createElement(UitkDialogContent, null, /* @__PURE__ */ React12.createElement(AdditionalInformationPopoverSections, {
        data: enrichedSecondaries
    }), footer && /* @__PURE__ */ React12.createElement(PricePresentationAdditionalInformationDialogFooter, {
        closeDialog: toggleDialog,
        data: footer
    })))));
};
PricePresentationAdditionalInformationDialog.fragment = fragment10;
PricePresentationAdditionalInformationDialog.displayName = "PricePresentationAdditionalInformationDialog";
// src/components/price-presentation/__private/__fragments/price-presentation-additional-information-popover.tsx
import React13 from "react";
import { gql as gql14 } from "@apollo/client";
import { useClickTracker as useClickTracker4 } from "@shared-ui/clickstream-analytics-context";
import { UitkIcon as UitkIcon4, UitkIconSize as UitkIconSize4 } from "uitk-react-icons";
import { UitkLayoutFlex as UitkLayoutFlex3 } from "uitk-react-layout-flex";
import { UitkLink as UitkLink3 } from "uitk-react-link";
import { PositionType as PositionType2, UitkMenu as UitkMenu2, UitkMenuContainer as UitkMenuContainer2, UitkMenuTrigger as UitkMenuTrigger2 } from "uitk-react-menu";
import { UitkMoreInfoTrigger as UitkMoreInfoTrigger3 } from "uitk-react-more-info-trigger";
import { UitkSpacing as UitkSpacing5 } from "uitk-react-spacing";
var fragment11 = gql14(_templateObject13(), AdditionalInformationPopoverSections.fragment);
var PricePresentationAdditionalInformationPopover = function(param) {
    var data = param.data, primaryMessage = param.primaryMessage, textProps = param.textProps;
    var icon = data.icon, analytics = data.analytics, enrichedSecondaries = data.enrichedSecondaries;
    var _React13_useState = _slicedToArray(React13.useState(false), 2), isMenuOpen = _React13_useState[0], setIsMenuOpen = _React13_useState[1];
    var lineStartIcon = primaryMessage === null || primaryMessage === void 0 ? void 0 : primaryMessage.icon;
    var isLinkForPopup = (primaryMessage === null || primaryMessage === void 0 ? void 0 : primaryMessage.primary) && enrichedSecondaries && enrichedSecondaries.length > 0 && !icon;
    var track = useClickTracker4();
    if (!icon && !isLinkForPopup) {
        return null;
    }
    var toggleMenuOpen = function() {
        if (!isMenuOpen && analytics) {
            track(analytics.referrerId, analytics.linkName, false);
        }
        setIsMenuOpen(function(prevState) {
            return !prevState;
        });
    };
    var _ref;
    return /* @__PURE__ */ React13.createElement(UitkMenu2, {
        isOpen: isMenuOpen,
        onTriggerClick: toggleMenuOpen
    }, /* @__PURE__ */ React13.createElement(UitkMenuTrigger2, null, /* @__PURE__ */ React13.createElement("div", null, icon && /* @__PURE__ */ React13.createElement(UitkMoreInfoTrigger3, null, /* @__PURE__ */ React13.createElement("button", {
        "data-stid": "additional-menu-btn",
        type: "button"
    }, /* @__PURE__ */ React13.createElement(UitkLayoutFlex3, {
        alignItems: "center"
    }, lineStartIcon && /* @__PURE__ */ React13.createElement(UitkSpacing5, {
        margin: {
            inlineend: "one"
        }
    }, /* @__PURE__ */ React13.createElement("span", {
        "data-stid": "additional-menu-btn-discount-icon"
    }, /* @__PURE__ */ React13.createElement(UitkIcon4, {
        name: lineStartIcon.id,
        id: lineStartIcon.id,
        size: (_ref = lineStartIcon.size && UitkIconSize4[lineStartIcon.size]) !== null && _ref !== void 0 ? _ref : UitkIconSize4.EXTRA_SMALL,
        theme: "secondary",
        title: lineStartIcon.description
    }))), /* @__PURE__ */ React13.createElement(PricePresentationAdditionalInformationHeader, {
        primaryMessage: primaryMessage,
        textProps: textProps
    }), /* @__PURE__ */ React13.createElement(UitkSpacing5, {
        margin: {
            inlinestart: "one"
        }
    }, /* @__PURE__ */ React13.createElement("span", {
        "data-stid": "additional-menu-btn-info-icon"
    }, /* @__PURE__ */ React13.createElement(UitkIcon4, {
        name: icon.id,
        id: icon.id,
        size: UitkIconSize4.EXTRA_SMALL,
        theme: "secondary",
        title: icon.description
    })))))), isLinkForPopup && /* @__PURE__ */ React13.createElement(UitkLink3, {
        inline: true,
        "data-stid": "additional-menu-link"
    }, /* @__PURE__ */ React13.createElement("button", {
        type: "button"
    }, primaryMessage === null || primaryMessage === void 0 ? void 0 : primaryMessage.primary)))), (enrichedSecondaries === null || enrichedSecondaries === void 0 ? void 0 : enrichedSecondaries.length) && /* @__PURE__ */ React13.createElement(UitkMenuContainer2, {
        autoPosition: true,
        position: PositionType2.LEFT,
        width: 300
    }, /* @__PURE__ */ React13.createElement(UitkSpacing5, {
        padding: {
            inline: "three"
        }
    }, /* @__PURE__ */ React13.createElement("div", null, /* @__PURE__ */ React13.createElement(AdditionalInformationPopoverSections, {
        data: enrichedSecondaries
    })))));
};
PricePresentationAdditionalInformationPopover.fragment = fragment11;
PricePresentationAdditionalInformationPopover.displayName = "PricePresentationAdditionalInformationPopover";
// src/components/price-presentation/__private/__fragments/price-presentation-additional-information.tsx
var fragment12 = gql15(_templateObject14(), PricePresentationAdditionalInformationDialog.fragment, PricePresentationAdditionalInformationPopover.fragment);
var PricePresentationAdditionalInformation = function(param) {
    var data = param.data, isRenderedInDialog = param.isRenderedInDialog, primaryMessage = param.primaryMessage, textProps = param.textProps;
    switch(data.__typename){
        case "PricePresentationAdditionalInformationDialog":
            return /* @__PURE__ */ React14.createElement(PricePresentationAdditionalInformationDialog, {
                data: data,
                isRenderedInDialog: isRenderedInDialog,
                primaryMessage: primaryMessage,
                textProps: textProps
            });
        case "PricePresentationAdditionalInformationPopover":
            return /* @__PURE__ */ React14.createElement(PricePresentationAdditionalInformationPopover, {
                data: data,
                primaryMessage: primaryMessage,
                textProps: textProps
            });
        default:
            return null;
    }
};
PricePresentationAdditionalInformation.fragment = fragment12;
PricePresentationAdditionalInformation.displayName = "PricePresentationAdditionalInformation";
// src/components/price-presentation/__private/__fragments/ui-graphic.tsx
import React17 from "react";
import { gql as gql18 } from "@apollo/client";
// src/components/price-presentation/__private/__fragments/illustration.tsx
import React15 from "react";
import { gql as gql16 } from "@apollo/client";
import { UitkIllustrations } from "uitk-react-illustrations";
var IllustrationFragment = gql16(_templateObject15());
var Illustration = function(param) {
    var data = param.data;
    return /* @__PURE__ */ React15.createElement(UitkIllustrations, {
        alt: data.description,
        url: data.link
    });
};
Illustration.displayName = "Illustration";
Illustration.fragment = IllustrationFragment;
// src/components/price-presentation/__private/__fragments/mark.tsx
import React16 from "react";
import { gql as gql17 } from "@apollo/client";
import { UitkMark, UitkMarkSize } from "uitk-react-mark";
var MarkFragment = gql17(_templateObject16());
var Mark = function(param) {
    var className = param.className, data = param.data;
    var _data_url;
    /* @__PURE__ */ return React16.createElement(UitkMark, {
        className: className,
        description: data.description,
        id: data.id,
        name: data.id,
        size: data.markSize ? UitkMarkSize[data.markSize] : void 0,
        url: (_data_url = data.url) === null || _data_url === void 0 ? void 0 : _data_url.value
    });
};
Mark.displayName = "Mark";
Mark.fragment = MarkFragment;
// src/components/price-presentation/__private/__fragments/ui-graphic.tsx
var __UIGraphicFragment = gql18(_templateObject17(), Icon.fragment, Mark.fragment, Illustration.fragment);
var UiGraphic = function(param) {
    var className = param.className, data = param.data;
    switch(data.__typename){
        case "Icon":
            return /* @__PURE__ */ React17.createElement(Icon, {
                className: className,
                data: data
            });
        case "Mark":
            return /* @__PURE__ */ React17.createElement(Mark, {
                className: className,
                data: data
            });
        case "Illustration":
            return /* @__PURE__ */ React17.createElement(Illustration, {
                data: data
            });
        default:
            return null;
    }
};
UiGraphic.displayName = "UiGraphic";
UiGraphic.fragment = __UIGraphicFragment;
// src/components/price-presentation/__private/__fragments/price-line-text.tsx
var primaryFragment = gql19(_templateObject18(), PricePresentationAdditionalInformation.fragment, UiGraphic.fragment);
var PriceLineText = function(props) {
    var data = props.data, isRenderedInDialog = props.isRenderedInDialog, size = props.size;
    if (!(data === null || data === void 0 ? void 0 : data.primary)) {
        return null;
    }
    var additionalInfo = data.additionalInfo, additionalInformation = data.additionalInformation, primary = data.primary, theme = data.theme, weight = data.weight, icon = data.icon, graphic = data.graphic, __typename = data.__typename;
    var textProps = {
        size: size || 300
    };
    var _ref;
    return /* @__PURE__ */ React18.createElement(React18.Fragment, null, additionalInfo && /* @__PURE__ */ React18.createElement(AdditionalInformationPopover, {
        primaryMessage: data,
        data: additionalInfo
    }), !additionalInfo && additionalInformation && /* @__PURE__ */ React18.createElement(PricePresentationAdditionalInformation, {
        data: additionalInformation,
        isRenderedInDialog: isRenderedInDialog,
        primaryMessage: {
            primary: primary,
            theme: theme,
            weight: weight,
            icon: icon,
            graphic: graphic,
            __typename: __typename
        },
        textProps: textProps
    }), !additionalInfo && !additionalInformation && /* @__PURE__ */ React18.createElement(UitkText4, {
        size: textProps.size,
        theme: theme ? textThemeMapper[theme] : void 0,
        weight: weight ? textWeightMapper[weight] : void 0
    }, /* @__PURE__ */ React18.createElement(UitkLayoutFlex4, null, graphic ? /* @__PURE__ */ React18.createElement(UitkSpacing6, {
        margin: {
            inlineend: "two"
        }
    }, /* @__PURE__ */ React18.createElement(UitkLayoutFlexItem, null, /* @__PURE__ */ React18.createElement(UiGraphic, {
        data: graphic
    }))) : icon && /* @__PURE__ */ React18.createElement(UitkSpacing6, {
        margin: {
            inlineend: "two"
        }
    }, /* @__PURE__ */ React18.createElement(UitkLayoutFlexItem, null, /* @__PURE__ */ React18.createElement(UitkIcon5, {
        name: icon.id,
        id: icon.id,
        size: (_ref = icon.size && UitkIconSize5[icon.size]) !== null && _ref !== void 0 ? _ref : UitkIconSize5.EXTRA_SMALL,
        theme: "secondary",
        title: icon.description
    }))), /* @__PURE__ */ React18.createElement(UitkLayoutFlexItem, {
        grow: 1
    }, /* @__PURE__ */ React18.createElement(UitkLayoutFlex4, {
        direction: "column"
    }, /* @__PURE__ */ React18.createElement(UitkText4, null, primary))))));
};
PriceLineText.fragment = primaryFragment;
PriceLineText.fragment.__typename = "PriceLineText";
PriceLineText.displayName = "PriceLineText";
// src/components/price-presentation/__private/__fragments/inline-price-line-text.tsx
var fragment13 = gql20(_templateObject19(), PriceLineText.fragment);
var InlinePriceLineText = function(param) {
    var size = param.size, data = param.data;
    var inlineItems = data.inlineItems;
    if (!inlineItems.length) {
        return null;
    }
    return /* @__PURE__ */ React19.createElement(UitkLayoutFlex5, {
        space: "one",
        wrap: "wrap"
    }, inlineItems.map(function(item, index) {
        return /* @__PURE__ */ React19.createElement(PriceLineText, {
            size: size,
            data: item,
            key: index
        });
    }));
};
InlinePriceLineText.fragment = fragment13;
InlinePriceLineText.fragment.__typename = "InlinePriceLineText";
InlinePriceLineText.displayName = "InlinePriceLineText";
// src/components/price-presentation/__private/__fragments/price-line-badge.tsx
import React21 from "react";
import { gql as gql22 } from "@apollo/client";
// ../internal/src/components/egds-standard-badge/egds-standard-badge.tsx
import React20 from "react";
import { gql as gql21 } from "@apollo/client";
import { UitkBadgeStandard } from "uitk-react-badge";
// ../internal/src/utils/egds-badge-themes-map.ts
var standardBadgeThemesMap = {
    standard: "standard",
    emphasis: "emphasis",
    info: "info",
    featured: "featured",
    brand: "brand",
    warning: "warning",
    positive: "positive"
};
// ../internal/src/components/egds-standard-badge/egds-standard-badge.tsx
var fragment14 = gql21(_templateObject20());
var EGDSStandardBadge = function(param) {
    var size = param.size, data = param.data;
    if (!data.text) {
        return null;
    }
    var text = data.text, theme = data.theme, accessibility = data.accessibility;
    var badgeTheme = theme ? standardBadgeThemesMap[theme] : void 0;
    return /* @__PURE__ */ React20.createElement(UitkBadgeStandard, {
        size: size,
        text: text,
        theme: badgeTheme,
        a11yText: accessibility !== null && accessibility !== void 0 ? accessibility : void 0
    });
};
EGDSStandardBadge.fragment = fragment14;
EGDSStandardBadge.displayName = "EGDSStandardBadge";
// src/components/price-presentation/__private/__fragments/price-line-badge.tsx
var fragment15 = gql22(_templateObject21(), EGDSStandardBadge.fragment);
var PriceLineBadge = function(param) {
    var data = param.data;
    if (!data.badge) {
        return null;
    }
    return /* @__PURE__ */ React21.createElement(EGDSStandardBadge, {
        data: data.badge
    });
};
PriceLineBadge.fragment = fragment15;
PriceLineBadge.displayName = "PriceLineBadge";
// src/components/price-presentation/__private/__fragments/price-line-heading.tsx
import React22 from "react";
import { gql as gql23 } from "@apollo/client";
import { UitkHeading as UitkHeading3 } from "uitk-react-text";
var primaryFragment2 = gql23(_templateObject22(), AdditionalInformationPopover.fragment, PricePresentationAdditionalInformation.fragment);
var PriceLineHeading = function(param) {
    var data = param.data, isRenderedInDialog = param.isRenderedInDialog;
    if (!(data === null || data === void 0 ? void 0 : data.primary)) {
        return null;
    }
    var additionalInfo = data.additionalInfo, additionalInformation = data.additionalInformation, primary = data.primary, size = data.size, tag = data.tag;
    return /* @__PURE__ */ React22.createElement(React22.Fragment, null, additionalInfo && /* @__PURE__ */ React22.createElement(AdditionalInformationPopover, {
        primaryMessage: data,
        data: additionalInfo
    }), !additionalInfo && additionalInformation && /* @__PURE__ */ React22.createElement(PricePresentationAdditionalInformation, {
        data: additionalInformation,
        isRenderedInDialog: isRenderedInDialog,
        primaryMessage: data
    }), !additionalInfo && !additionalInformation && /* @__PURE__ */ React22.createElement(UitkHeading3, {
        size: Number(size),
        tag: tag
    }, primary));
};
PriceLineHeading.fragment = primaryFragment2;
PriceLineHeading.fragment.__typename = "PriceLineHeading";
PriceLineHeading.displayName = "PriceLineHeading";
// src/components/price-presentation/__private/__fragments/price-line-element.tsx
var fragment16 = gql24(_templateObject23(), PriceLineText.fragment, PriceLineHeading.fragment, InlinePriceLineText.fragment, PriceLineBadge.fragment);
var PriceLineElement = function(param) {
    var data = param.data, isRenderedInDialog = param.isRenderedInDialog, size = param.size;
    switch(data.__typename){
        case "PriceLineText":
            return /* @__PURE__ */ React23.createElement(PriceLineText, {
                size: size,
                data: data,
                isRenderedInDialog: isRenderedInDialog
            });
        case "PriceLineHeading":
            return /* @__PURE__ */ React23.createElement(PriceLineHeading, {
                data: data,
                isRenderedInDialog: isRenderedInDialog
            });
        case "InlinePriceLineText":
            return /* @__PURE__ */ React23.createElement(InlinePriceLineText, {
                size: size,
                data: data
            });
        case "PriceLineBadge":
            return /* @__PURE__ */ React23.createElement(PriceLineBadge, {
                data: data
            });
        default:
            return null;
    }
};
PriceLineElement.fragment = fragment16;
PriceLineElement.displayName = "PriceLineElement";
// src/components/price-presentation/__private/__fragments/price-presentation-sub-section.tsx
import React26 from "react";
import { gql as gql27 } from "@apollo/client";
import { UitkSpacing as UitkSpacing9 } from "uitk-react-spacing";
import { UitkTableCell as UitkTableCell3, UitkTableCellPadding as UitkTableCellPadding3, UitkTableRow as UitkTableRow3 } from "uitk-react-tables";
import { UitkHeading as UitkHeading4 } from "uitk-react-text";
// src/components/price-presentation/__private/__fragments/price-presentation-line-item.tsx
import React25 from "react";
import { gql as gql26 } from "@apollo/client";
import { UitkSpacing as UitkSpacing8 } from "uitk-react-spacing";
import { UitkTableCell as UitkTableCell2, UitkTableCellPadding as UitkTableCellPadding2, UitkTableRow as UitkTableRow2 } from "uitk-react-tables";
// src/components/price-presentation/__private/__fragments/price-presentation-line-item-entry.tsx
import React24 from "react";
import { gql as gql25 } from "@apollo/client";
import { UitkSpacing as UitkSpacing7 } from "uitk-react-spacing";
var fragment17 = gql25(_templateObject24(), PriceLineElement.fragment);
var PricePresentationLineItemEntry = function(props) {
    var data = props.data, isRenderedInDialog = props.isRenderedInDialog, padding = props.padding, lineElementTextSize = props.lineElementTextSize;
    if (!data) {
        return null;
    }
    var primaryMessage = data.primaryMessage, secondaryMessages = data.secondaryMessages;
    var secondaryMessageLineElements = secondaryMessages.map(function(response, index) {
        return /* @__PURE__ */ React24.createElement(PriceLineElement, {
            key: index,
            size: 200,
            data: response
        });
    });
    return /* @__PURE__ */ React24.createElement(React24.Fragment, null, /* @__PURE__ */ React24.createElement(PriceLineElement, {
        size: lineElementTextSize || 300,
        data: primaryMessage,
        isRenderedInDialog: isRenderedInDialog
    }), padding && secondaryMessages.length > 0 ? /* @__PURE__ */ React24.createElement(UitkSpacing7, {
        padding: padding
    }, /* @__PURE__ */ React24.createElement("div", null, secondaryMessageLineElements)) : secondaryMessageLineElements);
};
PricePresentationLineItemEntry.fragment = fragment17;
PricePresentationLineItemEntry.fragment.__typename = "PricePresentationLineItemEntry";
PricePresentationLineItemEntry.displayName = "PricePresentationLineItemEntry";
// src/components/price-presentation/__private/__fragments/price-presentation-line-item.tsx
var fragment18 = gql26(_templateObject25(), PricePresentationLineItemEntry.fragment);
var PricePresentationLineItem = function(props) {
    var isRenderedInDialog = props.isRenderedInDialog, padding = props.padding, data = props.data, lineElementTextSize = props.lineElementTextSize;
    if (!data) {
        return null;
    }
    var name = data.name, enrichedValue = data.enrichedValue;
    return /* @__PURE__ */ React25.createElement(UitkTableRow2, null, /* @__PURE__ */ React25.createElement(UitkTableCell2, {
        colSpan: enrichedValue ? 1 : 2,
        padding: UitkTableCellPadding2.zero,
        align: {
            vertical: "top"
        }
    }, /* @__PURE__ */ React25.createElement(UitkSpacing8, {
        padding: padding
    }, /* @__PURE__ */ React25.createElement("div", null, /* @__PURE__ */ React25.createElement(PricePresentationLineItemEntry, {
        data: name,
        isRenderedInDialog: isRenderedInDialog,
        padding: {
            inlinestart: "two"
        },
        lineElementTextSize: lineElementTextSize
    })))), /* @__PURE__ */ React25.createElement(React25.Fragment, null, enrichedValue && /* @__PURE__ */ React25.createElement(UitkTableCell2, {
        align: {
            horizontal: "trailing",
            vertical: "top"
        },
        padding: UitkTableCellPadding2.zero
    }, /* @__PURE__ */ React25.createElement(UitkSpacing8, {
        padding: padding
    }, /* @__PURE__ */ React25.createElement("div", null, /* @__PURE__ */ React25.createElement(PricePresentationLineItemEntry, {
        data: enrichedValue,
        isRenderedInDialog: isRenderedInDialog,
        lineElementTextSize: lineElementTextSize
    }))))));
};
PricePresentationLineItem.fragment = fragment18;
PricePresentationLineItem.fragment.__typename = "PricePresentationLineItem";
PricePresentationLineItem.displayName = "PricePresentationLineItem";
// src/components/price-presentation/__private/__fragments/price-presentation-sub-section.tsx
var fragment19 = gql27(_templateObject26(), PricePresentationLineItem.fragment);
var PricePresentationSubSection = function(props) {
    var idx = props.idx, isRenderedInDialog = props.isRenderedInDialog, padding = props.padding, data = props.data, lineElementTextSize = props.lineElementTextSize;
    if (!data) {
        return null;
    }
    var header = data.header, items = data.items;
    var primaryMessage = header === null || header === void 0 ? void 0 : header.name.primaryMessage;
    var heading = ((primaryMessage === null || primaryMessage === void 0 ? void 0 : primaryMessage.__typename) === "PriceLineHeading" || (primaryMessage === null || primaryMessage === void 0 ? void 0 : primaryMessage.__typename) === "PriceLineText") && (primaryMessage === null || primaryMessage === void 0 ? void 0 : primaryMessage.primary);
    var headingValue = header === null || header === void 0 ? void 0 : header.enrichedValue;
    return /* @__PURE__ */ React26.createElement(React26.Fragment, null, heading && /* @__PURE__ */ React26.createElement(UitkTableRow3, null, /* @__PURE__ */ React26.createElement(UitkTableCell3, {
        colSpan: headingValue ? 1 : 2,
        padding: UitkTableCellPadding3.zero,
        align: {
            vertical: "top"
        }
    }, /* @__PURE__ */ React26.createElement(UitkSpacing9, {
        padding: padding
    }, /* @__PURE__ */ React26.createElement("div", null, /* @__PURE__ */ React26.createElement(UitkHeading4, {
        tag: "h3",
        size: 7
    }, heading)))), /* @__PURE__ */ React26.createElement(React26.Fragment, null, headingValue && /* @__PURE__ */ React26.createElement(UitkTableCell3, {
        align: {
            horizontal: "trailing",
            vertical: "top"
        },
        padding: UitkTableCellPadding3.zero
    }, /* @__PURE__ */ React26.createElement(UitkSpacing9, {
        padding: padding
    }, /* @__PURE__ */ React26.createElement("div", null, /* @__PURE__ */ React26.createElement(PricePresentationLineItemEntry, {
        data: headingValue,
        isRenderedInDialog: isRenderedInDialog
    })))))), items.map(function(item, itemIndex) {
        return /* @__PURE__ */ React26.createElement(PricePresentationLineItem, {
            key: itemIndex,
            data: item,
            isRenderedInDialog: isRenderedInDialog,
            padding: itemIndex || idx ? {
                blockstart: "three"
            } : void 0,
            lineElementTextSize: lineElementTextSize
        });
    }));
};
PricePresentationSubSection.fragment = fragment19;
PricePresentationSubSection.fragment.__typename = "PricePresentationSubSection";
PricePresentationSubSection.displayName = "PricePresentationSubSection";
// src/components/price-presentation/__private/__fragments/price-presentation-section.tsx
var fragment20 = gql28(_templateObject27(), PricePresentationSubSection.fragment);
var PricePresentationSection = function(props) {
    var _header_name, _header_enrichedValue, _header_enrichedValue1;
    var data = props.data, isRenderedInDialog = props.isRenderedInDialog, lineElementTextSize = props.lineElementTextSize;
    var header = data.header, subSections = data.subSections;
    var sectionHeading = header === null || header === void 0 ? void 0 : (_header_name = header.name) === null || _header_name === void 0 ? void 0 : _header_name.primaryMessage;
    var sectionPrimaryValue = header === null || header === void 0 ? void 0 : (_header_enrichedValue = header.enrichedValue) === null || _header_enrichedValue === void 0 ? void 0 : _header_enrichedValue.primaryMessage;
    var sectionSecondaryValues = header === null || header === void 0 ? void 0 : (_header_enrichedValue1 = header.enrichedValue) === null || _header_enrichedValue1 === void 0 ? void 0 : _header_enrichedValue1.secondaryMessages;
    if (!data || !sectionHeading && !sectionPrimaryValue && !subSections.length) {
        return null;
    }
    return /* @__PURE__ */ React27.createElement(UitkCardContentSection, {
        padded: false
    }, /* @__PURE__ */ React27.createElement(UitkTable2, {
        overflow: false
    }, /* @__PURE__ */ React27.createElement(UitkTableBody2, null, /* @__PURE__ */ React27.createElement(React27.Fragment, null, sectionHeading && /* @__PURE__ */ React27.createElement(UitkTableRow4, null, /* @__PURE__ */ React27.createElement(UitkTableCell4, {
        colSpan: sectionPrimaryValue ? 1 : 2,
        padding: UitkTableCellPadding4.zero,
        align: {
            vertical: "top"
        }
    }, /* @__PURE__ */ React27.createElement(UitkSpacing10, {
        padding: subSections.length ? {
            blockend: "three"
        } : void 0
    }, /* @__PURE__ */ React27.createElement("div", null, /* @__PURE__ */ React27.createElement(PriceLineElement, {
        size: 400,
        data: sectionHeading,
        isRenderedInDialog: isRenderedInDialog
    })))), /* @__PURE__ */ React27.createElement(React27.Fragment, null, sectionPrimaryValue && /* @__PURE__ */ React27.createElement(UitkTableCell4, {
        align: {
            horizontal: "trailing",
            vertical: "top"
        },
        padding: UitkTableCellPadding4.zero
    }, /* @__PURE__ */ React27.createElement(UitkSpacing10, {
        padding: subSections.length ? {
            blockend: "three"
        } : void 0
    }, /* @__PURE__ */ React27.createElement("div", null, /* @__PURE__ */ React27.createElement(PriceLineElement, {
        size: 400,
        data: sectionPrimaryValue,
        isRenderedInDialog: isRenderedInDialog
    }), sectionSecondaryValues === null || sectionSecondaryValues === void 0 ? void 0 : sectionSecondaryValues.map(function(response, index) {
        return /* @__PURE__ */ React27.createElement(PriceLineElement, {
            key: index,
            size: 200,
            data: response,
            isRenderedInDialog: isRenderedInDialog
        });
    }))))))), /* @__PURE__ */ React27.createElement(React27.Fragment, null, subSections.map(function(section, sectionIndex) {
        return /* @__PURE__ */ React27.createElement(PricePresentationSubSection, {
            key: sectionIndex,
            idx: sectionIndex,
            isRenderedInDialog: isRenderedInDialog,
            padding: sectionIndex ? {
                blockstart: "three"
            } : {
                blockend: "three"
            },
            data: section,
            lineElementTextSize: lineElementTextSize
        });
    })))));
};
PricePresentationSection.fragment = fragment20;
PricePresentationSection.fragment.__typename = "PricePresentationSection";
PricePresentationSection.displayName = "PricePresentationSection";
// src/components/price-presentation/price-presentation.tsx
import React29 from "react";
import { gql as gql29 } from "@apollo/client";
import { useHeadingLevelContext } from "@shared-ui/heading-level-context";
import { UitkSpacing as UitkSpacing12 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading6 } from "uitk-react-text";
// src/components/price-presentation/price-presentation-skeleton.tsx
import React28 from "react";
import { UitkLineSkeleton } from "uitk-react-skeleton";
import { UitkSpacing as UitkSpacing11 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading5 } from "uitk-react-text";
var SkeletonBody = function() {
    return /* @__PURE__ */ React28.createElement(React28.Fragment, null, /* @__PURE__ */ React28.createElement(UitkSpacing11, {
        margin: {
            blockstart: "three",
            blockend: "two"
        }
    }, /* @__PURE__ */ React28.createElement("div", null, /* @__PURE__ */ React28.createElement(UitkLineSkeleton, {
        animation: true,
        type: "primary"
    }))), /* @__PURE__ */ React28.createElement(UitkSpacing11, {
        margin: {
            blockend: "six"
        }
    }, /* @__PURE__ */ React28.createElement("div", null, /* @__PURE__ */ React28.createElement(UitkLineSkeleton, {
        animation: true,
        type: "secondary"
    }))), /* @__PURE__ */ React28.createElement(UitkSpacing11, {
        margin: {
            blockend: "six"
        }
    }, /* @__PURE__ */ React28.createElement("div", null, /* @__PURE__ */ React28.createElement(UitkLineSkeleton, {
        animation: true,
        type: "primary"
    }))), /* @__PURE__ */ React28.createElement(UitkSpacing11, null, /* @__PURE__ */ React28.createElement("div", null, /* @__PURE__ */ React28.createElement(UitkLineSkeleton, {
        animation: true,
        type: "primary"
    }))));
};
var PricePresentationSkeleton = function(param) {
    var header = param.header;
    return /* @__PURE__ */ React28.createElement(React28.Fragment, null, header && /* @__PURE__ */ React28.createElement(UitkHeading5, {
        tag: "h2",
        size: 5
    }, header), /* @__PURE__ */ React28.createElement(SkeletonBody, null));
};
// src/components/price-presentation/price-presentation.tsx
var fragment21 = gql29(_templateObject28(), PricePresentationSection.fragment, PriceLineElement.fragment);
var PricePresentation = function(props) {
    var _sections__subSections;
    var data = props.data, isRenderedInDialog = props.isRenderedInDialog, loading = props.loading;
    var title = data.title, sections = data.sections, footer = data.footer;
    var headingLevel = useHeadingLevelContext(1).headingLevel;
    var _useHeadingLevelContext = useHeadingLevelContext(2), nextHeadingLevel = _useHeadingLevelContext.headingLevel;
    if (!data || (sections === null || sections === void 0 ? void 0 : sections.length) === 0 || ((_sections__subSections = sections === null || sections === void 0 ? void 0 : sections[0].subSections) === null || _sections__subSections === void 0 ? void 0 : _sections__subSections.length) === 0) {
        return null;
    }
    if (loading) {
        return /* @__PURE__ */ React29.createElement(PricePresentationSkeleton, {
            header: title === null || title === void 0 ? void 0 : title.primary
        });
    }
    var primaryTitle = title === null || title === void 0 ? void 0 : title.primary;
    return /* @__PURE__ */ React29.createElement("div", {
        "data-stid": "price-summary-card"
    }, primaryTitle && /* @__PURE__ */ React29.createElement(UitkSpacing12, {
        padding: {
            blockend: "three"
        }
    }, /* @__PURE__ */ React29.createElement(UitkHeading6, {
        tag: headingLevel !== null && headingLevel !== void 0 ? headingLevel : "h2",
        size: 5
    }, primaryTitle)), /* @__PURE__ */ React29.createElement(React29.Fragment, null, sections.map(function(section, sectionIndex) {
        return /* @__PURE__ */ React29.createElement(React29.Fragment, {
            key: sectionIndex
        }, sectionIndex > 0 && /* @__PURE__ */ React29.createElement(UitkSpacing12, {
            margin: {
                blockend: "six",
                blockstart: "six"
            },
            border: [
                "blockend"
            ]
        }, /* @__PURE__ */ React29.createElement("div", null)), /* @__PURE__ */ React29.createElement(PricePresentationSection, {
            data: section,
            isRenderedInDialog: isRenderedInDialog
        }));
    })), footer && /* @__PURE__ */ React29.createElement(React29.Fragment, null, /* @__PURE__ */ React29.createElement(UitkHeading6, {
        tag: nextHeadingLevel !== null && nextHeadingLevel !== void 0 ? nextHeadingLevel : "h3",
        size: 7
    }, footer.header), footer.messages.map(function(footerData, index) {
        return /* @__PURE__ */ React29.createElement(UitkSpacing12, {
            key: "price-detail-footer-message-".concat(index),
            padding: {
                blockstart: "six"
            }
        }, /* @__PURE__ */ React29.createElement("div", null, /* @__PURE__ */ React29.createElement(PriceLineElement, {
            size: 200,
            data: footerData,
            isRenderedInDialog: isRenderedInDialog
        })));
    })));
};
PricePresentation.fragment = fragment21;
PricePresentation.fragment.__typename = "PricePresentation";
PricePresentation.displayName = "PricePresentation";
export { PricePresentation, PricePresentationSection };
//# sourceMappingURL=index.js.map